import moment from "moment";
import momentBusiness from "moment-business";

const ONE_MINUTE_MS = 60 * 1000;
const ONE_HOUR_MS = ONE_MINUTE_MS * 60;

export const QUEUE_STATUS = {
  WAITING: {
    value: "WAITING",
    display: "Waiting 等位中",
  },
  CALLING: {
    value: "CALLING",
    display: "Calling 正在叫号",
  },
  ASSIGNED: {
    value: "ASSIGNED",
    display: "Assigned 已分配桌位",
  },
  EXPIRED: {
    value: "EXPIRED",
    display: "Expired 已过号",
  },
  CANCELLED: {
    value: "CANCELLED",
    display: "Cancelled 已取消",
  },
};

export function getNumberOfCustomerSelections(min, max = 30) {
  return Array(max - min + 1)
    .fill(0)
    .map((_, i) => i + min);
}

export function decorateQueue(queue) {
  queue.createdTimeDisplay = moment(queue.createdTime).format(
    "ddd h:mma, D MMM YYYY"
  );
  queue.statusDisplay =
    (QUEUE_STATUS[queue.status] && QUEUE_STATUS[queue.status].display) || "N/A";
  const calledHistory = (queue.statusHistory || []).find(
    (history) => history.to === QUEUE_STATUS.CALLING.value
  );
  const timeWaitedMs = calledHistory
    ? new Date(calledHistory.time) - new Date(queue.createdTime).getTime()
    : Date.now() - new Date(queue.createdTime).getTime();
  if (timeWaitedMs < ONE_MINUTE_MS) {
    queue.timeWaitedDisplay = "Less than a minute";
  } else if (timeWaitedMs >= ONE_MINUTE_MS && timeWaitedMs < ONE_HOUR_MS) {
    const timeWaitedMin = Math.floor(timeWaitedMs / 1000 / 60);
    queue.timeWaitedDisplay = `${timeWaitedMin} minute${(timeWaitedMin === 1 &&
      "") ||
      "s"}`;
  } else {
    const timeWaitedHr = Math.floor(timeWaitedMs / 1000 / 60 / 60);
    queue.timeWaitedDisplay = `${timeWaitedHr} hour${(timeWaitedHr === 1 &&
      "") ||
      "s"}`;
  }
  queue.isToday = moment(queue.dineInDate).isSame(moment(new Date()), "day");
  queue.isFinalised = isQueueFinalised(queue);
}

export function isQueueFinalised(queue) {
  return [
    QUEUE_STATUS.ASSIGNED.value,
    QUEUE_STATUS.EXPIRED.value,
    QUEUE_STATUS.CANCELLED.value,
  ].includes(queue.status);
}

export function getReservationDates(numberOfDays) {
  return [...Array(numberOfDays)].map((_, i) =>
    moment()
      .add(i, "day")
      .format("ddd D MMM YYYY")
  );
}

export function getReservationTimeslots(selectedDateMoment, reservationRules) {
  const timeslots = [];
  const isWeekDay = momentBusiness.isWeekDay(selectedDateMoment);
  let startTime = moment()
    .hours(10)
    .minutes(0)
    .seconds(0)
    .milliseconds(0);
  if (isWeekDay) {
    startTime = startTime.minutes(30);
    while (startTime.hour() <= 23) {
      timeslots.push({
        value: startTime.toDate(),
        display: startTime.format("hh:mma"),
      });
      if (startTime.hour() === 15 && startTime.minute() === 0) {
        startTime = startTime
          .hours(17)
          .minutes(0)
          .seconds(0)
          .milliseconds(0);
        continue;
      }
      if (startTime.hour() === 21 && startTime.minute() === 0) {
        break;
      }
      startTime.add(15, "m");
    }
  } else {
    while (startTime.hour() <= 21) {
      timeslots.push({
        value: startTime.toDate(),
        display: startTime.format("hh:mma"),
      });
      if (startTime.hour() === 21 && startTime.minute() === 0) {
        break;
      }
      startTime.add(15, "m");
    }
  }

  if (!reservationRules) {
    return timeslots;
  }

  const enabledSlots = reservationRules.timeslots
    .filter((slot) => slot.toLowerCase().endsWith("am") || slot.toLowerCase().endsWith("pm"))
    .map((slot) => slot.split("-")[0].toLowerCase());
  return timeslots.filter((slot) => enabledSlots.includes(slot.display));
}
